<template>
  <button
    class="zord-button"
    :class="{
      'zord-button--fluid': isFluid,
      'zord-button--basic': isBasic,
      'zord-button--leading-icon': hasLeadingIcon,
      'zord-button--primary': isPrimary,
      'zord-button--rounded': isRounded,
    }"
  >
    <slot v-if="hasLeadingIcon" name="leadingIcon" />
    {{ label }}
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    label: {
      type: String,
      default: ''
    },
    isFluid: {
      type: Boolean,
      default: false
    },
    isBasic: {
      type: Boolean,
      default: false
    },
    hasLeadingIcon: {
      type: Boolean,
      default: false
    },
    isPrimary: {
      type: Boolean,
      default: false
    },
    isRounded: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style lang="scss" scoped>
  .zord-button {
    padding: var(--box-spacing);
    background-color: var(--white);
    border: var(--default-border);
    border-radius: var(--border-radius-l);
    min-width: 7.5rem;

    &:hover,
    &:focus
    &:active {
      border-color: var(--primary-color);
    }

    &--fluid {
      width: 100%;
    }

    &--basic {
      padding-right: 0;
      padding-left: 0;
      color: var(--secondary-grey);
      background-color: transparent;
      border: 0;
    }

    &--primary {
      padding: 0.875rem var(--spacing-xl);
      font-size: 1rem;
      font-weight: var(--font-weight-semibold);
      line-height: var(--spacing-s);
      color: var(--white);
      background-color: var(--primary-color);
      border-color: var(--primary-color);
      border-radius: var(--border-radius-rounded);
      box-shadow: var(--button-primary-shadow);
      transition: all 0.2s ease-in-out;

      &:hover,
      &:active {
        background-color: var(--primary-color-hover);
      }

      &:focus {
        box-shadow: var(--button-primary-focus-shadow);
      }

      &:disabled {
        background-color: var(--inactive-grey);
        border-color: var(--inactive-grey);
        pointer-events: none;
        box-shadow: var(--default-box-shadow);
      }
    }

    &--rounded {
      border-radius: 500em;
    }

    &--leading-icon {
      display: flex;
      align-items: center;
      gap: 0 var(--spacing-xs);
    }
  }
</style>
